export default class DropDownMenu {
    constructor(_root) {
        this.root = _root;
        this.button = Array.from(this.root.querySelectorAll(".neos-dropdown-toggle"));
        this.menu = Array.from(this.root.querySelectorAll(".neos-dropdown-menu"));
        this.setupEventListeners();
    }
    setupEventListeners() {
        this.button.forEach((_toggleButton) => {
            _toggleButton.addEventListener("click", this.toggle.bind(this));
        });
    }
    toggle(_event) {
        this.changeToogleIcon();
        this.root.classList.toggle("neos-dropdown-open");
    }
    changeToogleIcon() {
        const openIcon = this.root.querySelector(".fa-chevron-down");
        const closeIcon = this.root.querySelector(".fa-chevron-up");
        if (openIcon) {
            openIcon.classList.replace("fa-chevron-down", "fa-chevron-up");
        }
        if (closeIcon) {
            closeIcon.classList.replace("fa-chevron-up", "fa-chevron-down");
        }
    }
}
